// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountMaintenanceFeesThresholdPropertyDto
 */
export interface IAccountMaintenanceFeesThresholdPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IAccountMaintenanceFeesThresholdPropertyDto
     */
    account_maintenance_fees_threshold?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountMaintenanceFeesThresholdPropertyDto
     */
    account_maintenance_fees_threshold_state?: IAccountMaintenanceFeesThresholdPropertyDtoAccountMaintenanceFeesThresholdStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAccountMaintenanceFeesThresholdPropertyDtoAccountMaintenanceFeesThresholdStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IAccountMaintenanceFeesThresholdPropertyDto interface.
 */
export function instanceOfIAccountMaintenanceFeesThresholdPropertyDto(value: object): value is IAccountMaintenanceFeesThresholdPropertyDto {
    return true;
}

export function IAccountMaintenanceFeesThresholdPropertyDtoFromJSON(json: any): IAccountMaintenanceFeesThresholdPropertyDto {
    return IAccountMaintenanceFeesThresholdPropertyDtoFromJSONTyped(json, false);
}

export function IAccountMaintenanceFeesThresholdPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountMaintenanceFeesThresholdPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_maintenance_fees_threshold': json['account_maintenance_fees_threshold'] == null ? undefined : json['account_maintenance_fees_threshold'],
        'account_maintenance_fees_threshold_state': json['account_maintenance_fees_threshold_state'] == null ? undefined : json['account_maintenance_fees_threshold_state'],
    };
}

export function IAccountMaintenanceFeesThresholdPropertyDtoToJSON(json: any): IAccountMaintenanceFeesThresholdPropertyDto {
    return IAccountMaintenanceFeesThresholdPropertyDtoToJSONTyped(json, false);
}

export function IAccountMaintenanceFeesThresholdPropertyDtoToJSONTyped(value?: IAccountMaintenanceFeesThresholdPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_maintenance_fees_threshold': value['account_maintenance_fees_threshold'],
        'account_maintenance_fees_threshold_state': value['account_maintenance_fees_threshold_state'],
    };
}

